import { useState } from 'react';

interface ApiResponse<T> {
  data: T | null;
  error: any; // Cambiamos el tipo de error a 'any'
  isLoading: boolean;
  fetchData: () => Promise<void>;
}

type HttpMethod = 'GET' | 'POST' | 'PUT' | 'DELETE';

const useFetch = <T>(
  method: HttpMethod,
  url: string,
  body?: any,
  headers?: Record<string, string>
): ApiResponse<T> => {
  const [data, setData] = useState<T | null>(null);
  const [error, setError] = useState<any>(null); // Cambiamos el tipo de error a 'any'
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const requestOptions: RequestInit = {
        method,
        mode: 'cors',
        headers: {
          ...headers,
          'Content-Type': 'application/json',
        },
      };
  
      // Agregar cuerpo solo si el método no es GET
      if (method !== 'GET') {
        requestOptions.body = body ? JSON.stringify(body) : undefined;
      }
      
      const response = await fetch(url, requestOptions);
      const responseData = await response.json();
      if (!response.ok) {
        throw responseData; // Lanzamos la respuesta de la API si la solicitud no es exitosa
      }
  
      setData(responseData);
    } catch (errorResponse) { // Capturamos la respuesta de la API si hay un error
      setError(errorResponse);
    } finally {
      setIsLoading(false);
    }
  };
  console.log('useFetchData:', data, error)
  return { data, error, isLoading, fetchData };
};

export default useFetch;